// extracted by mini-css-extract-plugin
export default {"raffle":"style_raffle__IvSRf","raffle__head":"style_raffle__head__vZopz","raffle__title":"style_raffle__title__2NSwr","raffle__card":"style_raffle__card__L5dOL"};